import React from "react";
import { Pin } from "lucide-react";

import { DiscussionCardDisplayer } from "@/main/react/card/DiscussionCardDisplayer";
import { MainPageListStack } from "@/main/react/list/MainPageListLayout";
import type { PinnedGroupDiscussionLike } from "@/main/react/group/GroupGovernanceTypes";
import type { SensitiveMaskingDirective } from "@/main/common/SensitivePreference";
import type { Localizer } from "@/main/react/Types";

export function GroupFeaturedDiscussionsBlock(props: {
    items: PinnedGroupDiscussionLike[];
    groupPublicId?: string;
    viewerIsLeaderOfGroup?: boolean;
    onPinnedDiscussionRemoved?: (discussionPublicId?: string, pinId?: number | null) => void;
    sensitiveMasking?: SensitiveMaskingDirective;
    localizer: Localizer;
}) {
    const {
        items,
        groupPublicId,
        viewerIsLeaderOfGroup = false,
        onPinnedDiscussionRemoved,
        sensitiveMasking,
        localizer,
    } = props;

    if (items.length === 0) {
        return null;
    }

    return (
        <section
            className="mb-4 rounded-2xl border border-border bg-card p-4"
            data-playwright-id="group-featured-discussions"
        >
            <div className="mb-4 flex items-start gap-3">
                <div className="mt-0.5 flex size-9 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
                    <Pin className="size-4.5" aria-hidden={true} />
                </div>
                <div className="min-w-0">
                    <h2 className="text-base font-semibold text-text-main">
                        {localizer("group.featured.title")}
                    </h2>
                    <p className="text-sm text-neutral-text">
                        {localizer("group.featured.subtitle")}
                    </p>
                </div>
            </div>

            <MainPageListStack>
                {items.map((discussion) => (
                    <DiscussionCardDisplayer
                        key={discussion.pinId ?? discussion.publicId ?? discussion.discussionId}
                        discussion={discussion}
                        currentGroupPinnedDiscussion={discussion}
                        viewerIsLeaderOfGroup={viewerIsLeaderOfGroup}
                        contextGroupPublicId={groupPublicId}
                        onGroupPinnedDiscussionRemoved={onPinnedDiscussionRemoved}
                        sensitiveMasking={sensitiveMasking}
                        localizer={localizer}
                    />
                ))}
            </MainPageListStack>
        </section>
    );
}
